import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-automatic-matching',
  templateUrl: './help-add-automatic-matching.component.html',
  styleUrls: ['./help-add-automatic-matching.component.scss']
})
export class HelpAddAutomaticMatchingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
